// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const PriceWrapper: StatelessFunctionalComponent<*> = styled.div`
  
  .Price {
    &-options-container {
      margin: 0 auto;
      max-width: 500px;
      color: var(--white-color);
    }

    &-info-container {
      border-radius: 3px;
      color: var(--black-color);
      background-color: var(--white-color);
      box-shadow: 0 7px 6px 0 rgba(0, 0, 0, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.09);
    }

    &-info-line {
      display: grid;
      height: 100%;
      color: var(--text-color-2);
      grid-template: "text numb" 
                    / 1fr  100px;
    }

    &-info-text {
      grid-area: "text";
      padding: 0px 5px 0px 12px;
      font-size: 1.3em;
      text-align: left;
      display: flex;
      align-items: center;
    }

    &-info-number {
      grid-area: "numb";
      font-size: 13px;
      padding: 0px 15px 0px 0px;
      font-weight: 900;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    &-value-container-on {
      position: relative;
      min-height: 130px;
      padding: 8px 16px;
      border-radius: 3px;
      display: grid;
      text-align: center;
      justify-content: center;
      align-items: center;
      background-image: linear-gradient(288deg, #0033a0, #00aec7);
      box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.35), 0 5px 6px 0 rgba(0, 0, 0, 0.24);
    }

    &-value-text-1 {
      font-size: 1.5em;
    }

    &-value-text-2 {
      font-size: 4em;
      font-weight: 500;
    }

    &-value-text-3 {
      font-size: 2em;
      font-weight: 500;
    }
  }
`;

export default PriceWrapper;
